import { integrationOptionProvider } from "@p0security/integrations-installer";

import type {
  PostgresLegacyCloudSqlInstaller,
  PostgresLegacyInstallTypeInstaller,
  PostgresLegacyRdsInstaller,
} from "./types";

const postgresLegacyCloudSqlInstaller: PostgresLegacyCloudSqlInstaller = {
  items: {
    projectId: {
      optionProvider: integrationOptionProvider("access-management", [
        {
          component: "iam-write",
          integration: "gcloud",
        },
      ]),
    },
  },
};

const postgresLegacyRdsInstaller: PostgresLegacyRdsInstaller = {
  items: {
    account: {
      optionProvider: integrationOptionProvider("access-management", [
        {
          component: "iam-write",
          integration: "aws",
        },
      ]),
    },
    connectivity: {
      options: {
        private: {
          items: {
            securityPerimeter: {
              optionProvider: integrationOptionProvider(
                "rds-security-perimeter",
                [
                  {
                    component: "rds-security-perimeter",
                    integration: "aws",
                  },
                ]
              ),
            },
          },
        },
      },
    },
  },
};

export const postgresLegacyInstallTypeInstaller: PostgresLegacyInstallTypeInstaller =
  {
    options: {
      "cloud-sql": postgresLegacyCloudSqlInstaller,
      rds: postgresLegacyRdsInstaller,
    },
  };
